import { render, staticRenderFns } from "./ConfirmPhoneViaCall.vue?vue&type=template&id=979ec94c&"
import script from "./ConfirmPhoneViaCall.vue?vue&type=script&lang=js&"
export * from "./ConfirmPhoneViaCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports